import React from 'react';
import { Container, Row, Col, TabContent, TabPane,
  Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { FaVial, FaUsers, FaBook } from 'react-icons/fa';
import dayjs from 'dayjs';
import classnames from 'classnames';
import HeaderBar from './Components/HeaderBar';
import FilterPanel from './Panels/FilterPanel';
import OverviewPanel2 from './Panels/OverviewPanel2';
import ComparePanel from './Panels/ComparePanel';
import ClusterPanel from './Panels/ClusterPanel';
import DimPanelGroup from './Panels/DimPanelGroup';
import TrendPanel from './Panels/TrendPanel';
import VolumePanel from './Panels/VolumePanel';
import TimePanel from './Panels/TimePanel';
import TimelinePanel2 from './Panels/TimelinePanel2';
import WHeatmapPanel from './Panels/WHeatmapPanel';
import DetailPanel from './Panels/DetailPanel';
import ListPanel from './Panels/ListPanel';
import VAProcess from './VAProcess'

const isNumber = subject => typeof subject === 'number'

class App extends VAProcess {

  state = {
    baseCompleted: false,
    welcomeBanner: false,
    loadTimeStamp: 0,
    filterTimeStamp: 0,
    activeCategory: 'organism',
    focusOrganismIndex: 0,
    focusTeamIndex: 0,
    focusAuthorIndex: 0,
  };
  filterPanel = undefined;

  componentDidMount() {
    this.requestBaseData();
  }

  checkCompletion() {
    let {
      itemsName,
      itemsEMMethod,
      itemsComponentType,
      itemsOrganism,
      itemsAuthor,
      itemsTeam,
      itemsEMDBStatus,
      itemsPaper,
      itemsPublication,
      itemsResolution,
      itemsReleaseDate,
      itemsGridCount,
      listEMMethod,
      listOrganism,
      listAuthor,
      listTeam,
      listPublication,
    } = this.base;
    if(itemsEMMethod && itemsComponentType && itemsOrganism && itemsAuthor && itemsTeam &&
      itemsEMDBStatus && itemsPaper && itemsPublication && itemsResolution && itemsReleaseDate &&
      itemsGridCount && itemsName && listEMMethod && listOrganism && listAuthor &&
      listTeam && listPublication)
    {
      this.generateEMDDataList();
      this.computeLevelValues();
      this.applyFilter([]);
      //this.applyPresetFilter_Virus_HomoSapiens();
      //this.applyPresetFilter_Virus_Immunodeficiency();
      //this.applyPresetFilter_Virus_Immunodeficiency_John_High();
      //this.applyPresetFilter_BakersYeast();
      //this.applyPresetFilter_4932_2014();
      //this.applyPresetFilter_4932_Yifan_2014();
      //this.applyPresetFilter_4932_Roland_2014();
      //this.applyPresetFilter_4932_Kiyoshi_2014();
      this.setState({baseCompleted: true, welcomeBanner: true, loadTimeStamp: new Date().getTime()});
      this.selectTeam(0);
    }
  }

  applyPresetFilter_Virus_HomoSapiens()
  {
    this.applyFilter([,{
      selection: [3]
    },{
      selection: [
        this.base.listOrganism.findIndex(o => o.id === '9606'),
      ]
    },,,,,]);
  }

  applyPresetFilter_Virus_Immunodeficiency()
  {
    this.applyFilter([,{
      selection: [3]
    },{
      selection: [
        this.base.listOrganism.findIndex(o => o.id === '11676'),
      ]
    },,,,,]);
  }

  applyPresetFilter_Virus_Immunodeficiency_John_High()
  {
    this.applyFilter([,{
      selection: [3]
    },{
      selection: [
        this.base.listOrganism.findIndex(o => o.id === '11676'),
      ]
    },{
      selection: [
        this.base.listAuthorFull.findIndex(f => f.name === 'John A. G. Briggs'),
        this.base.listAuthorFull.findIndex(f => f.name === 'Wim J. H. Hagen'),
        this.base.listAuthorFull.findIndex(f => f.name === 'Carsten Sachse'),
      ]
    },,,,]);
  }

  applyPresetFilter_BakersYeast()
  {
    let dateStart = dayjs('2002-05-25');
    this.applyFilter([,,{
      selection: [
        this.base.listOrganism.findIndex(o => o.id === '4930'),
        this.base.listOrganism.findIndex(o => o.id === '4932'),
        this.base.listOrganism.findIndex(o => o.id === '114525'),
        this.base.listOrganism.findIndex(o => o.id === '230603'),
        this.base.listOrganism.findIndex(o => o.id === '285006'),
        this.base.listOrganism.findIndex(o => o.id === '307796'),
        this.base.listOrganism.findIndex(o => o.id === '559292'),
        this.base.listOrganism.findIndex(o => o.id === '580240'),
        this.base.listOrganism.findIndex(o => o.id === '1177187'),
        this.base.listOrganism.findIndex(o => o.id === '1247190'),
      ]
    },,,,,{
      range: [dayjs('2014-05-01').diff(dateStart, 'day'), dayjs('2019-05-01').diff(dateStart, 'day')]
    }]);
  }

  applyPresetFilter_4932_2014()
  {
    let dateStart = dayjs('2002-05-25');
    this.applyFilter([,,{
      selection: [
        this.base.listOrganism.findIndex(o => o.id === '4932'),
      ]
    },,,,,{
      range: [dayjs('2014-05-01').diff(dateStart, 'day'), dayjs('2019-05-01').diff(dateStart, 'day')]
    }]);
  }

  applyPresetFilter_4932_Yifan_2014()
  {
    let dateStart = dayjs('2002-05-25');
    this.applyFilter([,,{
      selection: [
        this.base.listOrganism.findIndex(o => o.id === '4932'),
      ]
    },{
      selection: [
        this.base.listAuthorFull.findIndex(f => f.name === 'Yifan Cheng')
      ]
    },,,,{
      range: [dayjs('2014-05-01').diff(dateStart, 'day'), dayjs('2019-05-01').diff(dateStart, 'day')]
    }]);
  }

  applyPresetFilter_4932_Roland_2014()
  {
    let dateStart = dayjs('2002-05-25');
    this.applyFilter([,,{
      selection: [
        this.base.listOrganism.findIndex(o => o.id === '4932'),
      ]
    },{
      selection: [
        this.base.listAuthorFull.findIndex(f => f.name === 'Roland Beckmann')
      ]
    },,,,{
      range: [dayjs('2014-05-01').diff(dateStart, 'day'), dayjs('2019-05-01').diff(dateStart, 'day')]
    }]);
  }

  applyPresetFilter_4932_Kiyoshi_2014()
  {
    let dateStart = dayjs('2002-05-25');
    this.applyFilter([,,{
      selection: [
        this.base.listOrganism.findIndex(o => o.id === '4932'),
      ]
    },{
      selection: [
        this.base.listAuthorFull.findIndex(f => f.name === 'Kiyoshi Nagai')
      ]
    },,,,{
      range: [dayjs('2014-05-01').diff(dateStart, 'day'), dayjs('2019-05-01').diff(dateStart, 'day')]
    }]);
  }

  applyFilter(filters) {
    let {
      optionsEMMethod,
      optionsComponentType,
      optionsOrganism,
      optionsAuthorFull,
      optionsEMDBStatus,
      optionsPublication,
      optionsPaper,
    } = this.base;
    let dateStart = dayjs('2002-05-25');
    let dateEnd = dayjs();
    let overview = this.base.overviewEMDs;
    let timeRangeMax = dateEnd.diff(dateStart, 'day');
    let filterMap = this.base.dataListEMDs.map(d => {
      if(filters[0] && filters[0].selection.length !== optionsEMMethod.length) {
        if(filters[0].selection.find(m => d.m === m) === undefined)
          return false;
      }
      if(filters[1] && filters[1].selection.length !== optionsComponentType.length) {
        if(filters[1].selection.find(c => d.c.find(c1 => c1 === c) !== undefined) === undefined)
          return false;
      }
      if(filters[2] && filters[2].selection.length !== optionsOrganism.length) {
        if(filters[2].selection.find(o => d.o.find(o1 => o1 === o) !== undefined) === undefined)
          return false;
      }
      if(filters[3] && filters[3].selection.length !== optionsAuthorFull.length) {
        if(filters[3].selection.find(f => d.f.find(f1 => f1 === f) !== undefined) === undefined)
          return false;
      }
      if(filters[4] && filters[4].selection.length !== optionsEMDBStatus.length) {
        if(filters[4].selection.find(s => d.s === s) === undefined)
          return false;
      }
      if(filters[5] && filters[5].selection.length !== optionsPublication.length) {
        if(filters[5].selection.find(p => d.p === p) === undefined)
          return false;
      }
      if(filters[6] && (filters[6].range[0] > overview.resMin || filters[6].range[1] < overview.resMax)) {
        if(d.r < filters[6].range[0] || d.r > filters[6].range[1])
          return false;
      }
      if(filters[7] && (filters[7].range[0] > 0 || filters[7].range[1] < timeRangeMax)) {
        let timeDiff = dayjs(d.t).diff(dateStart, 'day')
        if(timeDiff < filters[7].range[0] || timeDiff > filters[7].range[1])
          return false;
      }
      if(filters[8] && (filters[8].range[0] > overview.dim0Min || filters[8].range[1] < overview.dim0Max)) {
        if(d.g[0] < filters[8].range[0] || d.g[0] > filters[8].range[1])
          return false;
      }
      if(filters[9] && filters[9].selection.length !== optionsPaper.length) {
        if(filters[9].selection.find(paper => d.d === paper) === undefined)
          return false;
      }
      return true;
    });
    this.filters = filters;
    let filterResults = this.translateMapToResults(filterMap);
    this.updateFilterResults1(filterResults);
  }

  translateMapToResults(filterMap) {
    return filterMap.map((m, index) => m ? index : -1).filter(m => (m >= 0));
  }

  updateVAInfo() {
    this.setState({filterTimeStamp: new Date().getTime()});
  }

  updateFilterResults1(filterResults) {
    this.updateFilterResults(filterResults);
    if(this.emdPanel)
      this.emdPanel.viewEMD(this.filtered.lastestEMDIndex);
  }

  drill = (selections => {
    this.filterPanel.drill(selections);
  }).bind(this)

  drillEMMethod = ((methodIndex) => {
    this.filterPanel.drill({method: [methodIndex]});
  }).bind(this)

  drillComponent = ((componentIndex) => {
    this.filterPanel.drill({component: [componentIndex]});
  }).bind(this)

  selectOrganism = (focusOrganismIndex => {
    this.setState({focusOrganismIndex})
  }).bind(this)

  drillOrganism = ((organismIndex) => {
    this.filterPanel.drill({
      organism: [isNumber(organismIndex) ? organismIndex : this.filtered.filterOrganisms[this.state.focusOrganismIndex].id]
    });
    this.setState({focusTeamIndex: 0, focusOrganismIndex: 0})
  }).bind(this)

  selectTeam = (focusTeamIndex => {
    let focusAuthorIndex = this.filtered.filterTeams.length ? this.filtered.filterTeams[focusTeamIndex].team[0] : 0;
    this.setState({focusTeamIndex, focusAuthorIndex})
  }).bind(this)

  drillTeam = ((teamIndex) => {
    let focusAuthorIndex = isNumber(teamIndex) ? teamIndex : this.filtered.filterTeams[this.state.focusTeamIndex].team[0];
    this.filterPanel.drill({author: [focusAuthorIndex]});
    this.setState({focusTeamIndex: 0, focusOrganismIndex: 0, focusAuthorIndex})
  }).bind(this)

  drillAuthor = ((authorIndex) => {
    this.filterPanel.drill({author: [authorIndex]});
    this.setState({focusTeamIndex: 0, focusOrganismIndex: 0, focusAuthorIndex : authorIndex})
  }).bind(this)

  drillEMDBStatus = ((statusIndex) => {
    this.filterPanel.drill({status: [statusIndex]});
  }).bind(this)

  drillPublication = ((publicationIndex) => {
    this.filterPanel.drill({publication: [publicationIndex]});
  }).bind(this)

  drillPaper = ((paperIndex) => {
    this.filterPanel.drill({paper: [paperIndex]});
  }).bind(this)

  selectEMD = (focusEMDIndex => {
    if(this.emdPanel) this.emdPanel.viewEMD(focusEMDIndex)
  }).bind(this)

  toggleCategory = (tab => {
    if (this.state.activeCategory !== tab) {
      this.setState({
        activeCategory: tab
      });
    }
  }).bind(this)

  toggleWelcomeBanner = (() => {
    this.setState(prevState => ({
      welcomeBanner: !prevState.welcomeBanner
    }));
  }).bind(this)

  embededCluster = ((maps) => {
    if(!this.embededClusterView)
      return;
    this.embededClusterView.updateEMRelationGraph(maps);
  }).bind(this)

  renderEntireSystem() {
    let {
      baseCompleted,
      welcomeBanner,
      activeCategory,
      focusOrganismIndex,
      focusTeamIndex,
      focusAuthorIndex,
    } = this.state;
    return (
      <Container>
        <Row>
          <Col className="panel" xs={12}>
            <HeaderBar text="Filter" />
            <FilterPanel
              base={this.base}
              filtered={this.filtered}
              filters={this.filters}
              ref={ref => this.filterPanel=ref}
              applyFilter={this.applyFilter.bind(this)}
              onEMDSelected={this.selectEMD}
              onDrill={this.drill}
            />
          </Col>
        </Row>
        <Row>
          <Col className="panel" xs={3}>
            <Row>
              <Col className="panel">
                <HeaderBar text="Temporal" />
                <TimePanel
                  ref={ref => this.timePanel = ref}
                  base={this.base}
                  filtered={this.filtered}
                  filterTimeStamp={this.state.filterTimeStamp}
                  onEMDSelected={this.selectEMD}
                />
              </Col>
            </Row>
            <Row>
              <Col className="panel">
                <TimelinePanel2
                  base={this.base}
                  filtered={this.filtered}
                  filterTimeStamp={this.state.filterTimeStamp}
                  selectYearMonth={this.timePanel && this.timePanel.selectYearMonth}
                />
              </Col>
            </Row>
            <Row>
              <Col className="panel">
                <HeaderBar text="EM Entry" />
                <VolumePanel
                  base={this.base}
                  filtered={this.filtered}
                  filterTimeStamp={this.state.filterTimeStamp}
                  onEMMethodDrilled={this.drillEMMethod}
                  onComponentDrilled={this.drillComponent}
                  onOrganismDrilled={this.drillOrganism}
                  onAuthorDrilled={this.drillAuthor}
                  onEMDBStatusDrilled={this.drillEMDBStatus}
                  onPublicationDrilled={this.drillPublication}
                  onPaperDrilled={this.drillPaper}
                  ref={ref => this.emdPanel = ref}
                />
              </Col>
            </Row>
          </Col>
          <Col className="panel" xs={9}>
            <Row>
              <Col className="panel">
                <HeaderBar text="Evaluation" />
                <OverviewPanel2
                  base={this.base}
                  filtered={this.filtered}
                  filterTimeStamp={this.state.filterTimeStamp}
                  flat={true}
                />
              </Col>
            </Row>
            <HeaderBar text="Category" />
            <Row>
              <Col className="panel" xs={6}>
                <DetailPanel
                  base={this.base}
                  filtered={this.filtered}
                  filterTimeStamp={this.state.filterTimeStamp}
                  organismIndex={focusOrganismIndex}
                  teamIndex={focusTeamIndex}
                  authorIndex={focusAuthorIndex}
                  category={this.state.activeCategory}
                  onOrganismSelected={this.selectOrganism}
                  onTeamSelected={this.selectTeam}
                  onEMDSelected={this.selectEMD}
                  onDrill={this.drill}
                  onOrganismDrilled={this.drillOrganism}
                  onTeamDrilled={this.drillTeam}
                  toggleCategory={this.toggleCategory}
                />
              </Col>
              <Col className="panel" xs={6}>
                <ListPanel
                  base={this.base}
                  filtered={this.filtered}
                  filterTimeStamp={this.state.filterTimeStamp}
                  category={this.state.activeCategory}
                  onOrganismSelected={this.selectOrganism}
                  onTeamSelected={this.selectTeam}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal isOpen={welcomeBanner} toggle={this.toggleWelcomeBanner}>
          <ModalHeader toggle={this.toggleWelcomeBanner}>Welcome to VASEM : Visual Analytics System for EMDB</ModalHeader>
          <ModalBody>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleWelcomeBanner}>Close</Button>
          </ModalFooter>
        </Modal>
        <Modal style={{ 'max-width': '3200px', margin: 'auto' }} isOpen={!baseCompleted} fade={false}>
          <ModalBody style={{ height: '1000px' }}>
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%,-50%)'
            }}>
            <center>
              <Spinner type="grow" color="primary" />
              <Spinner type="grow" color="secondary" />
              <Spinner type="grow" color="success" />
              <Spinner type="grow" color="danger" />
              <Spinner type="grow" color="warning" />
              <Spinner type="grow" color="info" />
              <Spinner type="grow" color="dark" /><br />
              <h4>Loading data ...</h4>
            </center>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    );
  }

  renderEntireSystemFlat() {
    let {
      baseCompleted,
      welcomeBanner,
      activeCategory,
      focusOrganismIndex,
      focusTeamIndex,
      focusAuthorIndex,
    } = this.state;
    return (
      <Container style={{width: '2400px', 'max-width': '2400px'}}>
        <Row>
          <Col xs={8}>
            <Row>
              <Col className="panel" xs={12}>
                <HeaderBar text="Filter" />
                <FilterPanel
                  base={this.base}
                  filtered={this.filtered}
                  filters={this.filters}
                  ref={ref => this.filterPanel=ref}
                  applyFilter={this.applyFilter.bind(this)}
                  onEMDSelected={this.selectEMD}
                  onDrill={this.drill}
                  onMapAnalyze={this.embededCluster}
                />
              </Col>
            </Row>
            <Row>
              <Col className="panel" xs={3}>
                <Row>
                  <Col className="panel">
                    <HeaderBar text="Temporal" />
                    <TimePanel
                      ref={ref => this.timePanel = ref}
                      base={this.base}
                      filtered={this.filtered}
                      filterTimeStamp={this.state.filterTimeStamp}
                      onEMDSelected={this.selectEMD}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="panel">
                    <TimelinePanel2
                      base={this.base}
                      filtered={this.filtered}
                      filterTimeStamp={this.state.filterTimeStamp}
                      selectYearMonth={this.timePanel && this.timePanel.selectYearMonth}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="panel">
                    <HeaderBar text="EM Entry" />
                    <VolumePanel
                      base={this.base}
                      filtered={this.filtered}
                      filterTimeStamp={this.state.filterTimeStamp}
                      onEMMethodDrilled={this.drillEMMethod}
                      onComponentDrilled={this.drillComponent}
                      onOrganismDrilled={this.drillOrganism}
                      onAuthorDrilled={this.drillAuthor}
                      onEMDBStatusDrilled={this.drillEMDBStatus}
                      onPublicationDrilled={this.drillPublication}
                      onPaperDrilled={this.drillPaper}
                      ref={ref => this.emdPanel = ref}
                    />
                  </Col>
                </Row>
              </Col>
              <Col className="panel" xs={9}>
                <HeaderBar text="Evaluation" />
                <Row>
                  <Col className="panel" xs={12}>
                    <OverviewPanel2
                      base={this.base}
                      filtered={this.filtered}
                      filterTimeStamp={this.state.filterTimeStamp}
                      flat={true}
                    />
                  </Col>
                </Row>
                <HeaderBar text="Category" />
                <Row>
                  <Col className="panel" xs={6}>
                    <DetailPanel
                      base={this.base}
                      filtered={this.filtered}
                      filterTimeStamp={this.state.filterTimeStamp}
                      organismIndex={focusOrganismIndex}
                      teamIndex={focusTeamIndex}
                      authorIndex={focusAuthorIndex}
                      category={this.state.activeCategory}
                      onOrganismSelected={this.selectOrganism}
                      onTeamSelected={this.selectTeam}
                      onEMDSelected={this.selectEMD}
                      onDrill={this.drill}
                      onOrganismDrilled={this.drillOrganism}
                      onTeamDrilled={this.drillTeam}
                      toggleCategory={this.toggleCategory}
                      onMapAnalyze={this.embededCluster}
                    />
                  </Col>
                  <Col className="panel" xs={6}>
                    <ListPanel
                      base={this.base}
                      filtered={this.filtered}
                      filterTimeStamp={this.state.filterTimeStamp}
                      category={this.state.activeCategory}
                      onOrganismSelected={this.selectOrganism}
                      onTeamSelected={this.selectTeam}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col style={{margin: '0px 180px 0px 20px'}}>
            <Row>
              <Col className="panel">
                <HeaderBar text="Cluster" />
                <ClusterPanel
                  base={this.base}
                  filtered={this.filtered}
                  ref={ref => this.embededClusterView = ref}
                  height={554}
                />
              </Col>
            </Row>
            <Row>
              <Col className="panel">
                <HeaderBar text="Comparison" />
                <ComparePanel
                  base={this.base}
                  filtered={this.filtered}
                  filterTimeStamp={this.state.filterTimeStamp}
                  compact={false}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal isOpen={welcomeBanner} toggle={this.toggleWelcomeBanner}>
          <ModalHeader toggle={this.toggleWelcomeBanner}>Welcome to VASEM : Visual Analytics System for EMDB</ModalHeader>
          <ModalBody>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleWelcomeBanner}>Close</Button>
          </ModalFooter>
        </Modal>
        <Modal style={{ 'max-width': '3200px', margin: 'auto' }} isOpen={!baseCompleted} fade={false}>
          <ModalBody style={{ height: '1000px' }}>
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%,-50%)'
            }}>
            <center>
              <Spinner type="grow" color="primary" />
              <Spinner type="grow" color="secondary" />
              <Spinner type="grow" color="success" />
              <Spinner type="grow" color="danger" />
              <Spinner type="grow" color="warning" />
              <Spinner type="grow" color="info" />
              <Spinner type="grow" color="dark" /><br />
              <h4>Loading data ...</h4>
            </center>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    );
  }

  renderTemporalOnly(sizeFactor) {
    let {
      activeCategory,
      focusOrganismIndex,
      focusTeamIndex,
      focusAuthorIndex,
    } = this.state;
    return (
      <Container style={{width: `${400 * sizeFactor}px`, 'max-width': `${400 * sizeFactor}px`}}>
        <Row>
          <Col className="panel">
            <HeaderBar text="Temporal" />
            <TimePanel
              ref={ref => this.timePanel = ref}
              base={this.base}
              filtered={this.filtered}
              filterTimeStamp={this.state.filterTimeStamp}
              onEMDSelected={this.selectEMD}
              sizeFactor={sizeFactor}
            />
          </Col>
        </Row>
        <Row>
          <Col className="panel">
            <TimelinePanel2
              base={this.base}
              filtered={this.filtered}
              filterTimeStamp={this.state.filterTimeStamp}
              selectYearMonth={this.timePanel && this.timePanel.selectYearMonth}
              sizeFactor={sizeFactor}
            />
          </Col>
        </Row>
      </Container>
    );
  }

  renderOverviewOnly(sizeFactor) {
    let {
      activeCategory,
      focusOrganismIndex,
      focusTeamIndex,
      focusAuthorIndex,
    } = this.state;
    return (
      <Container style={{width: `${1200 * sizeFactor}px`, 'max-width': `${1200 * sizeFactor}px`}}>
        <DimPanelGroup
          base={this.base}
          filtered={this.filtered}
          filterTimeStamp={this.state.filterTimeStamp}
          sizeFactor={sizeFactor}
        />
      </Container>
    );
  }

  renderFlatOverview(sizeFactor) {
    let {
      activeCategory,
      focusOrganismIndex,
      focusTeamIndex,
      focusAuthorIndex,
    } = this.state;
    return (
      <Container style={{width: `${1200 * sizeFactor}px`, 'max-width': `${1200 * sizeFactor}px`}}>
        <Row>
          <Col className="panel" xs={12}>
            <OverviewPanel2
              base={this.base}
              filtered={this.filtered}
              filterTimeStamp={this.state.filterTimeStamp}
              sizeFactor={sizeFactor}
              flat={true}
            />
          </Col>
        </Row>
      </Container>
    );
  }

  renderCategoryViewOnly(sizeFactor) {
    let {
      activeCategory,
      focusOrganismIndex,
      focusTeamIndex,
      focusAuthorIndex,
    } = this.state;
    return (
      <Container style={{width: `${1200 * sizeFactor}px`, 'max-width': `${1200 * sizeFactor}px`}}>
        <HeaderBar text="Category" />
        <Row>
          <Col className="panel" xs={6}>
            <DetailPanel
              base={this.base}
              filtered={this.filtered}
              filterTimeStamp={this.state.filterTimeStamp}
              organismIndex={focusOrganismIndex}
              teamIndex={focusTeamIndex}
              authorIndex={focusAuthorIndex}
              category={this.state.activeCategory}
              onOrganismSelected={this.selectOrganism}
              onTeamSelected={this.selectTeam}
              onEMDSelected={this.selectEMD}
              onDrill={this.drill}
              onOrganismDrilled={this.drillOrganism}
              onTeamDrilled={this.drillTeam}
              toggleCategory={this.toggleCategory}
              sizeFactor={sizeFactor}
            />
          </Col>
          <Col className="panel" xs={6}>
            <ListPanel
              base={this.base}
              filtered={this.filtered}
              filterTimeStamp={this.state.filterTimeStamp}
              category={this.state.activeCategory}
              onOrganismSelected={this.selectOrganism}
              onTeamSelected={this.selectTeam}
              sizeFactor={sizeFactor}
            />
          </Col>
        </Row>
      </Container>
    );
  }

  renderVolumeViewOnly(sizeFactor) {
    let {
      activeCategory,
      focusOrganismIndex,
      focusTeamIndex,
      focusAuthorIndex,
    } = this.state;
    return (
      <Container style={{width: `${1200 * sizeFactor}px`, 'max-width': `${1200 * sizeFactor}px`}}>
        <Row>
          <Col className="panel">
            <HeaderBar text="EM Entry" />
            <VolumePanel
              base={this.base}
              filtered={this.filtered}
              filterTimeStamp={this.state.filterTimeStamp}
              onEMMethodDrilled={this.drillEMMethod}
              onComponentDrilled={this.drillComponent}
              onOrganismDrilled={this.drillOrganism}
              onAuthorDrilled={this.drillAuthor}
              onEMDBStatusDrilled={this.drillEMDBStatus}
              onPublicationDrilled={this.drillPublication}
              onPaperDrilled={this.drillPaper}
              sizeFactor={sizeFactor}
              ref={ref => this.emdPanel = ref}
            />
          </Col>
        </Row>
      </Container>
    );
  }

  renderComparisonOnly(sizeFactor) {
    return (
      <Container style={{width: `${1200 * sizeFactor}px`, 'max-width': `${1200 * sizeFactor}px`}}>
        <Row>
          <Col className="panel">
            <HeaderBar text="Comparison" />
            <ComparePanel
              base={this.base}
              filtered={this.filtered}
              filterTimeStamp={this.state.filterTimeStamp}
              compact={false}
              extend={true}
              sizeFactor={sizeFactor}
            />
          </Col>
        </Row>
      </Container>
    );
  }

  render() {
    return this.renderEntireSystem();
    //return this.renderEntireSystemFlat();
    //return this.renderTemporalOnly(2);
    //return this.renderOverviewOnly(2);
    //return this.renderCategoryViewOnly(2);
    //return this.renderFlatOverview(1.5);
    //return this.renderVolumeViewOnly(2);
    //return this.renderComparisonOnly(1);
  }
}

export default App;
